const infos = [
  { label: "首都", value: "ダブリン（Dublin）", icon: "ri-building-2-line" },
  { label: "言語", value: "英語・アイルランド語（英語が主要言語）", icon: "ri-translate-2" },
  { label: "通貨", value: "ユーロ（€）1€≒160円", icon: "ri-money-euro-circle-line" },
  { label: "時差", value: "日本より-9時間（サマータイム時-8時間）", icon: "ri-time-zone-line" },
  { label: "気候", value: "温帯海洋性気候。夏15〜20℃、冬5〜10℃", icon: "ri-sun-cloudy-line" },
  { label: "人口", value: "約530万人（親日家が多いことで有名）", icon: "ri-group-line" },
  { label: "ビザ", value: "90日以内は観光ビザ不要。90日超は学生ビザ必要", icon: "ri-passport-line" },
  { label: "治安", value: "ヨーロッパ随一の安全な国として有名", icon: "ri-shield-check-line" },
];

export default function BasicInfoSection() {
  return (
    <section id="basicinfo" className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Basic Info</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            🇮🇪 アイルランドの基本情報 🇮🇪
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {infos.map((info, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-5 flex flex-row items-start gap-3 border border-emerald-100 hover:border-emerald-300 transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0">
                <i className={`${info.icon} text-lg`} />
              </div>
              <div>
                <div className="text-xs text-emerald-500 font-semibold mb-1">{info.label}</div>
                <div className="text-sm text-gray-700 font-medium leading-snug">{info.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
